<script lang="ts">
  import SVG_svelte from "./SVG_svelte.svelte";
  import { loadStylesheet, showModal } from "../common/helpers";
  import GameStatusDialog from "./GameStatusDialog";
  import AuthDialog from "./Auth/AuthDialog";
  import { onDestroy, onMount } from "svelte";
  import css from '../../css/v9/cards/game-square-card.pcss.json'

  export let gameId: number
  export let status: number

  const statusStrings = [
    'wishlist',
    'playing',
    'beaten',
    'sleep'
  ]

  let realStatus = (window.gameStatus && window.gameStatus[gameId]) ?? status

  const onClick = (e: MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    if (window.isLoggedIn) {
      showModal(GameStatusDialog, {
        gameId: gameId.toString(),
        iconSet: 'colorable'
      })
    } else {
      AuthDialog.show()
    }
  }

  const onStatusChanged = (e: CustomEvent) => {
    const detailId = parseInt(e.detail.gameId)
    if (detailId === gameId) {
      realStatus = e.detail.status
    }
  }

  onMount(() => {
    loadStylesheet('v9/cards/game-square-card')
    window.addEventListener('game-status-changed', onStatusChanged)
  })

  onDestroy(() => {
    window.removeEventListener('game-status-changed', onStatusChanged)
  })
</script>

<button
    type="button"
    class={css['status-button']}
    on:click={onClick}
    data-game-status-button
>
    {#if status >= 0}
        <SVG_svelte
            i={`game-status/colorable/${statusStrings[realStatus]}`}
            data-game-watch-icon="true"
            data-game-watch-icon-status={statusStrings[realStatus]}
        />
    {:else}
        <div data-game-watch-icon>
            <SVG_svelte i="sg-new/plus" adaptive/>
        </div>
    {/if}
</button>
